// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2CCd2","fileDisabled":"File_fileDisabled__22FKt"};